<template>
  <a-modal
    :bordered="false"
    title="企业主帐单结算"
    style="top: 20px;"
    :width="1500"
    v-model="billmainsettlementible"
    footer=""
  >
    <!--    表格内容-->
    <a-table
      :scroll="{ x: 1200 }"
      size="default"
      ref="table"
      rowKey="sourceId"
      :columns="columns"
      :dataSource="reslist"
      :pagination="false"
      bordered
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="settlementCompleted(record)">结算完成</a>
        <a-divider type="vertical" />

        <a
          v-if="
            (record.settleStatusCode == 2 || record.settleStatusCode == 3) &&
              record.statementStatusCode != 6 && record.statementStatusCode != 7
          "
          @click="refunda(record)"
          >退款</a
        >
        <a-divider
          type="vertical"
          v-if="
            (record.settleStatusCode == 2 || record.settleStatusCode == 3) &&
              record.statementStatusCode != 6 && record.statementStatusCode != 7
          "
        />
        <a @click="remarkList(record)">备注</a>
      </span>
    </a-table>
    <!--    生成对账单的按钮和方法-->
    <div style="margin-bottom: 16px">
      <a-button
        type="primary"
        @click="goEnterpriseStatement()"
        :loading="loading"
        style="margin-right: 20px;margin-top: 20px"
      >
        批量结算
      </a-button>
    </div>
    <!--    批量结算的弹框-->
    <a-modal
      title="结算"
      style="top: 20px;"
      :width="800"
      v-model="Settlementible"
      :confirmLoading="confirmLoading"
      @ok="EnterpriseOk"
      @cancel="handleCancel"
    >
      <a-form :form="formSettlement">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需支付">
          <a-input v-decorator="['needpayAmount']" disabled />
        </a-form-item>
        <!--<div v-if="!disable">-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际支付">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请填写实际支付金额!' }]
              }
            ]"
            :max="this.formSettlement.getFieldValue('needpayAmount')"
            @change="amountModify"
            :disabled="amountabled"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未支付">
          <a-input v-decorator="['Unpaid']" disabled="disabled" />
        </a-form-item>
        <!--</div>-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }]
              }
            ]"
          >
            <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <!--        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">-->
        <!--          <a-input type="textarea"  />-->
        <!--        </a-form-item>-->
      </a-form>
    </a-modal>
    <!--    // 退款-->
    <a-modal
      title="退款"
      style="top: 20px;"
      :width="800"
      v-model="refundible"
      :confirmLoading="confirmLoading"
      @ok="refundOk"
    >
      <a-form :form="refundform">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际收款">
          <a-input v-decorator="['realReceipts']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请输入退款金额!' }]
              }
            ]"
            :max="this.refundform.getFieldValue('realReceipts')"
            @change="amountModify"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="余额">
          <a-input v-decorator="['balance']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }]
              }
            ]"
          >
            <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <!--        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">-->
        <!--          <a-input type="textarea"   v-model="remark"/>-->
        <!--        </a-form-item>-->
      </a-form>
    </a-modal>
    <a-modal title="备注" style="top: 20px;" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
      <a-form-item style="display:none">
        <a-input v-decorator="['statementId']" />
      </a-form-item>
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
          <a-input v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>
<script>
import { STable } from '@/components'
import { saveRemark, getmajorSettleList } from '@/api/finance/enterpriseStatement'
// 调接口
import {
  getSourceList,
  queryAlreadyPay,
  getRefundList,
  queryNeedPay,
  getSettleList,
  batchSettleComplete
} from '@/api/finance/BillSettlement'
// 导入弹框vue
import EnterpriseModal from '../modules/CustomerModal.vue'
import EnterGenerateModal from '../modules/enterGenerateModal.vue'
import { getDictMap } from '../../../utils/dict'
import pick from 'lodash.pick'
export default {
  name: 'mainSettlement',
  components: {
    STable,
    // 注册弹框组件
    EnterpriseModal,
    EnterGenerateModal
  },
  data() {
    return {
      amountabled: false,

      refundible: false,
      billmainsettlementible: false,
      disable: false,
      refundid: '',
      realReceipts: '',
      refund: '',
      remark: '',
      payMethod: '',
      // 点收款保存的id
      statementId: '',
      // 批量结算返回的数据
      needpayAmount: '',
      // 实际支付金额
      actualpayAmount: '',
      // 单个结算id跳转带过来的数据
      majorStatementIds: '',
      reslist: [],
      // 复选框选择数据的id
      statementIds: [],
      // 复选框
      selectedRowKeys: [],
      selectedRow: [], // Check here to configure the default column
      loading: false,
      form: this.$form.createForm(this),
      refundform: this.$form.createForm(this),
      formSettlement: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '账单状态',
          dataIndex: 'statementStatus',
          align: 'center'
        },
        {
          title: '结算状态',
          dataIndex: 'settleStatus',
          align: 'center'
        },
        {
          title: '账单号',
          dataIndex: 'statementNo',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '结算总金额',
          dataIndex: 'enterpriseSettleAmount',
          align: 'center'
        },
        {
          title: '已结算金额',
          dataIndex: 'alreadySettleAmount',
          align: 'center'
        },
        {
          title: '实际需结算',
          dataIndex: 'needSettleAmounnt',
          align: 'center'
        },
        {
          title: '已退款金额',
          dataIndex: 'alreadyRefundAmount',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ],
      Settlementible: false,
      confirmLoading: false,
      orderid: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {
    // 字典为支付方式
    this.installTypes = []
    this.restaurantOperTypeMap = await getDictMap('pay_method')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.installTypes.push({ code: key, label: value })
    })

    // console.log(this.Settlementlist)
  },

  methods: {
    showmainsettlement(id) {
      this.selectedRowKeys = []
      this.selectedRow = []
      this.billmainsettlementible = true
      this.majorStatementIds = id
      getmajorSettleList({ majorStatementIds: this.majorStatementIds.join() }).then(res => {
        if (res.code === 0) {
          this.reslist = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkList(record) {
      this.remarkible = true
      this.form.resetFields()
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(record, 'remark', 'statementId'))
      })
      this.remarkstatementId = record.statementId
      // console.log(this.form.getFieldsValue())
      // if(record.remark){
      //   this.form.setFieldsValue({
      //     remark:record.remark,
      //   })
      // }
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.form.validateFields((err, values) => {
        values.statementType = 0
        values.statementId = this.remarkstatementId
        console.log(values)
        if (!err) {
          saveRemark(values).then(res => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              getmajorSettleList({ majorStatementIds: this.majorStatementIds.join() }).then(res => {
                if (res.code === 0) {
                  // // 响应的数据
                  // console.log(res)
                  this.reslist = res.data
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 计算未支付值
    amountModify(e) {
      let realReceipts = this.refundform.getFieldValue('realReceipts')
      this.refundform.setFieldsValue({
        balance: realReceipts - 0 - e
      })
      let needpayAmount = this.formSettlement.getFieldValue('needpayAmount')
      this.formSettlement.setFieldsValue({
        Unpaid: needpayAmount - 0 - e
      })
    },
    onSelectChange(selectedRowKeys, selectedRow) {
      this.selectedRow = selectedRow
      this.selectedRowKeys = selectedRowKeys
      // console.log(this.selectedRow)
    },
    // 确定时调用的方法
    EnterpriseOk() {
      this.formSettlement.validateFields((err, values) => {
        if (!err) {
          this.Settlementible = false
          this.amountabled = false
          this.confirmLoading = false
          if (!this.disable) {
            values.settleTargetType = 0
            ;(values.settleTargetId = this.statementId),
              getSettleList(values).then(res => {
                if (res.code === 0) {
                  this.$message.success('操作成功')
                  this.$emit('ok')
                  getmajorSettleList({ majorStatementIds: this.majorStatementIds.join() }).then(res => {
                    if (res.code === 0) {
                      this.reslist = res.data
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                } else {
                  this.$message.error(res.msg)
                }
              })
          }
          // 批量结算
          if (this.disable) {
            ;(values.statementIds = this.statementIds), (values.statementType = 0)
            console.log(values)
            batchSettleComplete(values).then(res => {
              if (res.code === 0) {
                this.$message.success('操作成功')
                this.$emit('ok')
                getmajorSettleList({ majorStatementIds: this.majorStatementIds.join() }).then(res => {
                  if (res.code === 0) {
                    this.reslist = res.data
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
      // if (this.statementId) {
      //   getSettleList({
      //     amount: this.needpayAmount,
      //     payMethod: this.payMethod,
      //     refundTargetId: this.statementId,
      //     settleTargetType: 1,
      //     remark:this.remark
      //   }).then(res => {
      //     console.log(res)
      //
      //   })
      // }
      // if (this.statementIds.join()) {
      //   batchSettleComplete({
      //     payMethod: this.payMethod,
      //     statementIds: this.statementIds,
      //     settleTargetType:"1",
      //     remark:this.remark
      //   }).then(res => {
      //     console.log(res)
      //
      //   })
      // }
      this.actualpayAmount = ''
      this.remark = ''
      this.payMethod = ''
      this.statementIds = []
    },
    // 取消时调用的方法
    // 取消时调用的方法
    handleCancel() {
      this.Enterprisevisible = false
      this.refundible = false

      this.selectedRowKeys = []
    },
    // 结算完成 批量结算
    goEnterpriseStatement() {
      this.statementIds = []
      // 有选中的值传id
      if (this.selectedRowKeys.length > 0) {
        this.amountabled = true
        this.Settlementible = true
        this.selectedRow.forEach(item => {
          return this.statementIds.push(item.statementId)
        })
        getSourceList({ statementType: 0, statementIds: this.statementIds.join() }).then(res => {
          if (res.code === 0) {
            // // 响应的数据
            // this.actualpayAmount =this.needpayAmount =res.data
            setTimeout(() => {
              this.formSettlement.setFieldsValue({
                needpayAmount: res.data,
                amount: res.data,
                Unpaid: res.data - 0 - res.data
              })
            }, 100)

            this.disable = true
            // console.log(this.needpayAmount)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择至少一条数据数据')
      }
    },
    settlementCompleted(record) {
      this.statementId = ''
      this.formSettlement.resetFields()
      this.statementId = record.statementId
      this.Settlementible = true
      this.amountabled = false
      queryNeedPay({ statementType: 0, statementId: record.statementId }).then(res => {
        if (res.code === 0) {
          setTimeout(() => {
            this.formSettlement.setFieldsValue({
              needpayAmount: res.data
            })
          }, 100)
          this.disable = false
          // console.log(this.needpayAmount)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 退款
    refunda(record) {
      this.refundform.resetFields()
      this.refundid = record.statementId
      this.refundible = true

      queryAlreadyPay({ statementType: 0, statementId: record.statementId }).then(res => {
        if (res.code === 0) {
          // // 响应的数据
          setTimeout(() => {
            this.refundform.setFieldsValue({
              realReceipts: res.data
            })
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 退款弹框确定
    refundOk() {
      this.refundform.validateFields((err, values) => {
        values.refundTargetId = this.refundid
        values.refundTargetType = 0
        if (!err) {
          this.refundible = false

          this.confirmLoading = false
          getRefundList(values).then(res => {
            if (res.code === 0) {
              this.$emit('ok')
              getmajorSettleList({ majorStatementIds: this.majorStatementIds.join() }).then(res => {
                if (res.code === 0) {
                  this.reslist = res.data
                } else {
                  this.$message.error(res.msg)
                }
              })
              this.$message.success('操作成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
      // getRefundList({
      //   amount: this.realReceipts,
      //   payMethod: this.payMethod,
      //   refundTargetId: this.refundid,
      //   settleTargetType: 1,
      //   remark:this.remark
      // }).then(res => {
      //   console.log(res)
      // })
      this.refund = ''
      this.remark = ''
      this.payMethod = ''
    },
    goEnterpriseBill() {
      this.$router.go(-1)
    }
  },
  watch: {},
  computed: {
    // Unpaid() {
    //     let Unpaidnum=this.needpayAmount-this.needpayAmount
    //     return Unpaidnum
    // },
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
